let n = 0;
const e = {
  start(i = {}) {
    console.log(i);
    const t = () => {
      var a;
      (a = window == null ? void 0 : window.navigator) == null || a.sendBeacon(
        "https://edu.py2fun.com/wiki-dynamic/api/online-users",
        JSON.stringify({
          user_id: i.user_id,
          nickname: i.nickname,
          avatar: i.avatar,
          vip_infos: i.vip_infos || [],
          is_login: i.is_login,
          location: window.location.href,
          learn_day: i.learn_day,
          register_time: i.register_time
        })
      );
    };
    t(), window.clearInterval(n), n = window.setInterval(t, 30 * 1e3);
  },
  dispose() {
    window.clearInterval(n);
  }
};
export {
  e as OnlineUserStatistics
};
//# sourceMappingURL=index.js.map
